var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "stitch": "",
      "fill-height": "",
      "help-content-id": "popup-customer-".concat(_vm.current_entity_profile)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$translate("title")))]), _vm.customer !== null ? _c('template', {
    slot: "rawcontent"
  }, [_c('div', {
    staticClass: "customercatalogs-modal d-flex flex-column min-height-0 h-100"
  }, [!_vm.ready ? _c('Loading', {
    attrs: {
      "absolute": false
    }
  }) : !_vm.catalogs_loading && _vm.catalogs_count === 0 ? _c('Placeholder', {
    attrs: {
      "title": _vm.$translate('noCatalogFound'),
      "description": _vm.$translate('noCatalogFoundDescription'),
      "actions": _vm.placeholderActions
    },
    on: {
      "on-action": _vm.onPlaceholderAction
    }
  }) : _c('div', {
    staticClass: "customercatalogs-modal-content d-flex flex-column flex-grow-1 min-height-0"
  }, [_c('div', {
    staticClass: "flex-shrink-0 mt-4 px-4"
  }, [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_vm._v(" " + _vm._s(_vm.$translate("catalogsTitle")) + " ")]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$translate('catalogsInstructions').replace('{customer}', _vm.customer.name))
    }
  })]), _c('div', {
    staticClass: "customercatalogs-modal-table flex-grow-1 min-height-0 overflow-y-auto"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.catalogs,
      "rows-count": _vm.catalogs_count,
      "loading": _vm.catalogs_loading,
      "filters": _vm.catalogs_filters,
      "filters-conf": _vm.filtersConf,
      "remote": true,
      "show-select": true,
      "item-key": 'id',
      "item-value": 'id',
      "value": _vm.allowedCatalogs,
      "items-per-page": _vm.catalogs_filters.limit,
      "single-select": _vm.current_entity_profile == 'operator'
    },
    on: {
      "on-filters-change": _vm.onFiltersChange,
      "on-row-click": _vm.onRowClick,
      "on-row-selected": _vm.onRowSelected,
      "on-row-deselected": _vm.onRowDeselected,
      "toggle-select-all": _vm.toggleSelectAll
    },
    scopedSlots: _vm._u([{
      key: "owner_name",
      fn: function fn(props) {
        return [props.row.provider ? _c('ProviderName', {
          attrs: {
            "provider": props.row.provider_data
          }
        }) : props.row.owner != _vm.current_entity_id ? _c('ProviderName', {
          attrs: {
            "provider": props.row.owner_data,
            "lookup": {
              entity: props.row.owner
            }
          }
        }) : [_vm._v(" " + _vm._s(_vm.current_entity_name) + " ")]];
      }
    }], null, false, 2093282541)
  })], 1)])], 1)]) : _vm._e(), _c('template', {
    slot: "bottom"
  }, [_vm.catalogs_count > 0 ? _c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    on: {
      "click": _vm.assignDefaultCatalogs
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("assignDefaultCatalogs")) + " ")]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("buttons.cancel")) + " ")]), _vm.catalogs_count > 0 ? _c('v-btn', {
    staticClass: "primary my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "disabled": _vm.customer_saving
    },
    on: {
      "click": _vm.assignCatalogsClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.saveText) + " ")]) : _vm._e()], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }